<template><div><h1 id="einheiten" tabindex="-1"><a class="header-anchor" href="#einheiten"><span>Einheiten</span></a></h1>
<p>Einheiten — Definition möglicher Masseneinheiten im Artikelstamm</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die im System möglichen Masseinheiten, welche im Artikelstamm eingegeben werden können. Nur Einträge aus dieser Tabelle sind möglich.</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Einheiten</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Einheit</dt>
<dd>Kürzel für die Masseinheit, 4-stellig, alphanumerisch</dd>
<dt>Bedeutung</dt>
<dd>Bezeichnung für die Masseinheit</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfuntkionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink>--&gt;</p>
</div></template>


